import { render, staticRenderFns } from "./Workshops.vue?vue&type=template&id=0d92d92d&scoped=true&"
import script from "./Workshops.vue?vue&type=script&lang=js&"
export * from "./Workshops.vue?vue&type=script&lang=js&"
import style0 from "./Workshops.vue?vue&type=style&index=0&id=0d92d92d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d92d92d",
  null
  
)

export default component.exports